import type { DmNotificationResolution } from '../../../services/dmNotifications';
import type { HistoryResolvedCount } from '../../../services/dmMonitoringOverviewHistory';

const IN_ODO_RESOLUTION: DmNotificationResolution = 'dashboard';
const IN_DM_RESOLUTION: DmNotificationResolution = 'dm';

export interface HandledSplit {
    inOdo: number;
    inDm: number;
}

export interface HandledTotals extends HandledSplit {
    total: number;
}

function countResolution(
    resolved: readonly HistoryResolvedCount[],
    resolution: DmNotificationResolution
): number {
    return resolved
        .filter((row) => row.resolution === resolution)
        .reduce((sum, row) => sum + row.count, 0);
}

// Across both categories; 'gone' and 'excluded' were never handled by a person.
export function handledTotals(resolved: readonly HistoryResolvedCount[]): HandledTotals {
    const inOdo = countResolution(resolved, IN_ODO_RESOLUTION);
    const inDm = countResolution(resolved, IN_DM_RESOLUTION);
    return { inOdo, inDm, total: inOdo + inDm };
}

// "3 in ODO · 1 in DM"; a side with none is left out, and both empty gives ''.
export function handledSplitLabel({ inOdo, inDm }: HandledSplit): string {
    const sides = [
        inOdo > 0 ? `${inOdo.toLocaleString()} in ODO` : null,
        inDm > 0 ? `${inDm.toLocaleString()} in DM` : null
    ];
    return sides.filter((side): side is string => side !== null).join(' · ');
}
